// File: client/src/variants/uno/index.js
// UNO X CHESS as a platform plugin.

import rulebook from './rulebook';
import { useUnoRuntime } from './useUnoRuntime';

const unoVariant = {
  id: 'uno',
  name: 'UNO X CHESS',
  tagline: 'Chess with chaos cards. Play one card a turn to bend the rules.',
  icon: '🃏',
  accent: 'from-fuchsia-600 to-purple-700',
  supportedGameTypes: ['ai', 'local'],
  order: 1,
  rulebook,
  useRuntime: useUnoRuntime,
};

export default unoVariant;
